
import { useEffect, useMemo, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, Card, CardContent, CardHeader, Checkbox, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from '@mui/material'

import UndoIcon from '@mui/icons-material/Undo';
import ClearIcon from '@mui/icons-material/Clear';
import LowPriorityIcon from '@mui/icons-material/LowPriority';

import moment from 'moment';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';

import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout'

import { ObtenerProceso } from '../../connections/catalogos/ProcesoConnection';
import { ObtenerUsuariosReasignacionCancelacion } from '../../connections/admin/UsuarioConnection';
import { BuscarReasignacionesCancelaciones, CancelarActividades, ReasignarActividades } from '../../connections/admin/ActividadConnection';

import { ProcesoProps } from '../../interfaces/catalogos/ProcesoInterface';
import { UsuarioReasignacionCancelacionResponse } from '../../interfaces/admin/UsuarioInterface';
import { BuscarReasignacionesCancelacionesResponse, CancelarActividadesParams, ReasignarActividadesParams } from '../../interfaces/admin/ActividadInterface';

export const AdministracionCasosPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [loading, setLoading] = useState( false );

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const [numeroSeguimiento, setNumeroSeguimiento] = useState( '' );
    const [referencia, setRefencia] = useState( '' );

    const [usuario, setUsuario] = useState( 0 );
    const [usuarioArray, setUsuarioArray] = useState<UsuarioReasignacionCancelacionResponse[]>( [] );

    const [proceso, setProceso] = useState( 0 );
    const [procesoArray, setProcesoArray] = useState<ProcesoProps[]>( [] );

    const [usuarioAsignacion, setUsuarioAsignacion] = useState( 0 );
    const [usuarioAsignacionTemp, setUsuarioAsignacionTemp] = useState( 0 );
    const [usuarioAsignacionArray, setUsuarioAsignacionArray] = useState<UsuarioReasignacionCancelacionResponse[]>( [] );

    const [rows, setRows] = useState<BuscarReasignacionesCancelacionesResponse[]>( [] );

    const [openCancelar, setOpenCancelar] = useState( false );
    const [loadingCancelacion, setLoadingCancelacion] = useState( false );

    const [openAsignacion, setOpenAsignacion] = useState( false );
    const [loadingAsignacion, setLoadingAsignacion] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const selectedRowsCount = useMemo(() => rows.filter((e) => e.selected === true).length, [rows]);
    const allRowsSelected = useMemo(() => rows.length > 0 && rows.every((e) => e.selected === true), [rows]);

    const handleSelectAll = (value: boolean) => {

        const newRows = rows.map((e) => ({ ...e, selected: value }));

        setRows( newRows );
    }

    const handleChangeSelected = (id: string, value: boolean) => {

        const newRows = rows.map((e) => e.id === id ? { ...e, selected: value } : e);

        setRows( newRows );
    }

    const handleBuscar = async () => {

        setFiltroAplicado(true);
        setLoading(true);
        setRows( [] );

        await BuscarReasignacionesCancelaciones({ numeroSeguimiento: numeroSeguimiento === '' ? 0 : parseInt( numeroSeguimiento ), idUsuario: usuario, idProceso: proceso ?? 0 }).then(resp => {

            setTimeout(() => {

                setRows(resp.map((e) => ({ ...e, selected: false })));

                setLoading( false );

            }, 700);

        });

    }

    const handleClearFiltro = () => {

        setFiltroAplicado( false );
        setNumeroSeguimiento( '' );
        setUsuario( 0 );
        setProceso( 0 )
        setRows( [] );

        resetPage();

    }

    const handleClose = () => {

        setOpenCancelar( false );
        setOpenAsignacion( false );
        setRefencia( '' );
        setUsuarioAsignacionTemp( 0 );
        setUsuarioAsignacion( 0 );
    }

    const handleGuardarCancelaciones = async () => {

        setLoadingCancelacion( true );

        const params: CancelarActividadesParams = {
            numeroSeguimiento: referencia !== ''
                ? [ referencia ]
                : rows.filter( (e) => e.selected ).map( (e) => e.numeroSeguimiento )
        };

        await CancelarActividades( params ).then(resp => {

            const { success, message } = resp;

            if ( success ) {

                setTimeout(() => {

                    const newArray = rows.filter( (e) => !params.numeroSeguimiento.includes( e.numeroSeguimiento ) );

                    setRows( newArray );

                    handleClose();
                    setLoadingCancelacion( false );

                    dispatch( openSnackbar({ message: message, variant: 'success' }) );

                }, 700);

            }
            else {

                dispatch( openSnackbar({ message: message, variant: 'error' }) );
                setLoadingCancelacion( false );

            }

        });

    }

    const handleGuardarAsignaciones = async () => {

        setLoadingAsignacion(true);

        const params: ReasignarActividadesParams = {
            idUsuario: usuarioAsignacion,
            numeroSeguimiento: referencia !== ''
                ? [ referencia ]
                : rows.filter( (e) => e.selected ).map((e) => e.numeroSeguimiento )
        };

        await ReasignarActividades( params ).then(resp => {

            const { success, message } = resp;

            if ( success ) {

                setTimeout(() => {

                    const newArray = rows.filter((e) => !params.numeroSeguimiento.includes( e.numeroSeguimiento ));

                    setRows( newArray );
                    setLoadingAsignacion( false );
                    handleClose();

                    dispatch( openSnackbar({ message: message, variant: 'success' }) );

                }, 700);

            }
            else {

                dispatch( openSnackbar({ message: message, variant: 'error' }) );
                setLoadingAsignacion( false );

            }

        });

    }

    useEffect(() => {

        async function Obtener() {

            setUsuario( 0 );
            setUsuarioArray( [] );

            await ObtenerUsuariosReasignacionCancelacion().then( resp => {

                setUsuarioArray( resp );
                setUsuarioAsignacionArray( resp );

            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerProceso().then( resp => {

                setProcesoArray( resp );

            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        if ( openAsignacion && usuarioAsignacionTemp !== 0 && usuarioAsignacionArray.length !== 0 ) {

            setUsuarioAsignacion( usuarioAsignacionTemp );

        }

    }, [openAsignacion, usuarioAsignacionTemp, usuarioAsignacionArray]);

    return (
        <Layout breadcrumbs={ [{ text: 'Administración' }, { text: 'Administración de casos' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                    <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                        Regresar
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>

                        <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={<Typography sx={{ fontWeight: '400', color: 'white' }}> Filtro(s) </Typography>} />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <FormControl fullWidth>

                                        <InputLabel>Proceso</InputLabel>
                                        <Select
                                            label='Proceso'
                                            value={ proceso }
                                            disabled={ filtroAplicado }
                                            onChange={ (e) => setProceso( e.target.value ) }
                                        >
                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                procesoArray
                                                .map(({ idProceso, descripcion }) => (
                                                    <MenuItem key={ idProceso } value={ idProceso }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <TextField
                                        fullWidth
                                        label='Número de seguimiento'
                                        variant='outlined'
                                        type='number'
                                        value={ numeroSeguimiento }
                                        onChange={ (e) => setNumeroSeguimiento( e.target.value ) }
                                        disabled={ filtroAplicado }
                                        slotProps={{
                                            input: {
                                                autoComplete: 'off'
                                            },
                                            inputLabel: {
                                                shrink: true,
                                            }
                                        }}
                                    />

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Usuario(s)</InputLabel>

                                        <Select
                                            label='Usuario(s)'
                                            value={ usuario }
                                            onChange={(e) => setUsuario( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                usuarioArray.map(({ idUsuario, nombreCompleto }) => (
                                                    <MenuItem key={ idUsuario } value={ idUsuario }>{ nombreCompleto }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <Button
                                        fullWidth
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        onClick={ () => filtroAplicado ? handleClearFiltro() : handleBuscar() }
                                        disabled={
                                            (
                                                numeroSeguimiento === '' &&
                                                proceso === 0 &&
                                                usuario === 0
                                            ) ||
                                                loading
                                        }
                                    >
                                        { filtroAplicado ? 'limpiar filtro' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <Grid container spacing={ 3 }>

                        <Grid size={{ md: 8, xs: 0 }}></Grid>

                        <Grid size={{ md: 2, xs: 12 }}>

                            <Button
                                fullWidth
                                variant='contained'
                                disabled={ selectedRowsCount < 2 }
                                onClick={ () => setOpenCancelar( true ) }
                            >
                                Cancelar
                            </Button>

                        </Grid>

                        <Grid size={{ md: 2, xs: 12 }}>

                            <Button
                                fullWidth
                                variant='contained'
                                disabled={ selectedRowsCount < 2 }
                                onClick={ () => setOpenAsignacion( true ) }
                            >
                                Reasignar
                            </Button>

                        </Grid>

                    </Grid>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} >

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table sx={{ minWidth: 500 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '19%', fontWeight: 'bold' }}> Número de seguimiento </TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%', fontWeight: 'bold' }}> Asignado a </TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%', fontWeight: 'bold' }}> Proceso (Módulo) </TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}> </TableCell>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '1%' }}>

                                    {
                                        rows.length !== 0
                                        &&
                                            <Tooltip title='Seleccionar todo'>
                                                <Checkbox
                                                    sx={{ bgcolor: 'white', borderRadius: 2, ':hover': { bgcolor: 'white' } }}
                                                    checked={ allRowsSelected }
                                                    onChange={ (e) => handleSelectAll( e.target.checked ) }
                                                />
                                            </Tooltip>
                                    }

                                    </TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                            {
                                (
                                    rowsPerPage > 0
                                    ?
                                        rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    :
                                        rows
                                ).map(({ id, numeroSeguimiento, fecha, actividad, proceso, idUsuario, usuario, selected }) => (

                                    <TableRow key={ id }>

                                        <TableCell>

                                            <Typography variant='h6' fontWeight={ 'bold' }>
                                                { numeroSeguimiento }
                                            </Typography>

                                            <Typography variant='subtitle2' mt={ 1 }>
                                                { fecha ? moment( fecha ).format( 'DD-MM-YYYY hh:mm a' ) : '' }
                                            </Typography>

                                        </TableCell>

                                        <TableCell>{ usuario }</TableCell>

                                        <TableCell>

                                            <Typography variant='h6' fontWeight={ 'bold' }>
                                                { proceso }
                                            </Typography>

                                            {
                                                actividad
                                                &&
                                                    <Chip
                                                        variant='filled'
                                                        sx={{ fontWeight: 'bold', mt: 1 }}
                                                        color={ 'default' }
                                                        label={
                                                            <Typography variant='subtitle1' fontWeight={ '600' } fontSize={ 14 }>
                                                                { actividad }
                                                            </Typography>
                                                        }
                                                    />
                                            }

                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                        {
                                            <Tooltip title='Cancelar'>

                                                <IconButton color='primary' onClick={() => { setRefencia( numeroSeguimiento ); setOpenCancelar( true ); }}>
                                                    <ClearIcon />
                                                </IconButton>

                                            </Tooltip>
                                        }

                                        {
                                            <Tooltip title='Reasignar'>

                                                <IconButton color='primary' sx={{ ml: 1 }} onClick={() => { setRefencia( numeroSeguimiento ); setUsuarioAsignacionTemp( idUsuario ); setOpenAsignacion( true ); }}>
                                                    <LowPriorityIcon />
                                                </IconButton>

                                            </Tooltip>
                                        }

                                        </TableCell>

                                        <TableCell>

                                        {
                                            <Checkbox
                                                checked={selected ?? false}
                                                onChange={(e) => handleChangeSelected(id, e.target.checked)}
                                            />
                                        }

                                        </TableCell>

                                    </TableRow>
                                ))
                            }

                            {
                                ( rows.length === 0 && !loading )
                                ?
                                    <TableRow style={{ height: 93 }}>

                                        <TableCell colSpan={ 7 } align='center'>

                                            <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                        </TableCell>

                                    </TableRow>
                                :
                                    loading
                                    &&
                                        <TableRow style={{ height: 93 }}>

                                            <TableCell colSpan={ 7 } align='center'>

                                                <CircularProgress size={ 26 } />

                                            </TableCell>

                                        </TableRow>
                            }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { rows.length } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        colSpan={ 8 }
                                        rowsPerPageOptions={[ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ]}
                                        count={ rows.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />
                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <Dialog
                fullWidth
                maxWidth='sm'
                open={ openCancelar }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <DialogContentText>
                    {
                        selectedRowsCount < 2
                        ?
                            '¿Desea cancelar el proceso seleccionado?'
                        :
                            '¿Desea cancelar los procesos seleccionados?'
                    }
                    </DialogContentText>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color='secondary' disabled={ loadingCancelacion } onClick={ handleClose }>Cancelar</Button>

                    <Button
                        variant='contained'
                        loading={ loadingCancelacion }
                        onClick={ handleGuardarCancelaciones }
                    >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog
                fullWidth
                maxWidth='sm'
                open={ openAsignacion }
            >

                <DialogTitle>
                    Asignación
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <FormControl fullWidth sx={{ mt: 1 }}>

                        <InputLabel>Usuarios disponibles</InputLabel>

                        <Select
                            label='Usuarios disponibles'
                            value={ usuarioAsignacion }
                            onChange={ (e) => setUsuarioAsignacion( e.target.value ) }
                        >
            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                            {
                                usuarioAsignacionArray.map(({ idUsuario, nombreCompleto }) => (
                                    <MenuItem key={ idUsuario } value={ idUsuario }>{ nombreCompleto }</MenuItem>
                                ))
                            }
                        </Select>

                    </FormControl>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color='secondary' onClick={ handleClose }>Cancelar</Button>

                    <Button
                        variant='contained'
                        loading={ loadingAsignacion }
                        disabled={ usuarioAsignacion === 0 }
                        onClick={ handleGuardarAsignaciones }
                    >
                        Guardar
                    </Button>

                </DialogActions>

            </Dialog>

        </Layout>
    )
}